<p-confirmDialog header="Atenção" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-toast></p-toast>
<div class="p-field p-col-12 p-md-12 p-lg-12" *ngIf="_loading">
  <p-progressBar mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>
</div>

<habil-grupo>
  <p-scrollPanel [style]="{ width: '100%', height: getScrollHeight() }">
    <p-accordion>
      <!-- Contexto: tudo aqui vem do código do ERP e é reescrito a cada publicação
           do catálogo. Fica visível porque é o que permite escrever a ajuda certa,
           mas não é editável para não dar a impressão de que a mudança se mantém. -->
      <p-accordionTab header="A rotina (vem do código, não se edita aqui)" [selected]="true">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-4">
            <habil-label name="txtRotina" label="Rotina">
              <input readonly type="text" name="txtRotina" pInputText [ngModel]="obj.rotina" />
            </habil-label>
          </div>
          <div class="p-field p-col-12 p-md-8">
            <habil-label name="txtTitulo" label="Título da tela">
              <input readonly type="text" name="txtTitulo" pInputText [ngModel]="obj.titulo" />
            </habil-label>
          </div>
          <div class="p-field p-col-12 p-md-8">
            <habil-label name="txtOndeFica" label="Onde fica no menu">
              <input readonly type="text" name="txtOndeFica" pInputText [ngModel]="obj.ondeFica" />
            </habil-label>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <habil-label name="txtPermissao" label="Permissão">
              <input readonly type="text" name="txtPermissao" pInputText [ngModel]="obj.permissao" />
            </habil-label>
          </div>
          <div class="p-field p-col-12">
            <habil-label name="txtRota" label="Rota">
              <input readonly type="text" name="txtRota" pInputText [ngModel]="obj.rota" />
            </habil-label>
          </div>

          <div class="p-field p-col-12" *ngIf="acoes.length">
            <label>O que a tela oferece</label>
            <div class="ajuda-chips">
              <span class="ajuda-chip" *ngFor="let a of acoes">{{ a }}</span>
            </div>
          </div>

          <div class="p-field p-col-12" *ngIf="relacionadas.length">
            <label>Rotinas relacionadas</label>
            <div class="ajuda-chips">
              <span class="ajuda-chip" *ngFor="let r of relacionadas">{{ r.nome }}</span>
            </div>
          </div>
        </div>
      </p-accordionTab>

      <p-accordionTab header="Texto da ajuda" [selected]="true">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12">
            <habil-label name="txtResumo" label="Resumo — o que a rotina resolve, em uma frase">
              <textarea
                [readonly]="_readonly"
                name="txtResumo"
                pInputTextarea
                rows="2"
                [(ngModel)]="obj.resumo"
              ></textarea>
            </habil-label>
          </div>

          <div class="p-field p-col-12">
            <habil-label name="txtQuandoUsar" label="Quando usar — em que momento do dia a dia se recorre a ela">
              <textarea
                [readonly]="_readonly"
                name="txtQuandoUsar"
                pInputTextarea
                rows="2"
                [(ngModel)]="obj.quandoUsar"
              ></textarea>
            </habil-label>
          </div>

          <div class="p-field p-col-12">
            <habil-label
              name="txtConteudo"
              label="Passo a passo (markdown) — use ## para as seções, deixe vazio para ficha curta"
            >
              <textarea
                [readonly]="_readonly"
                name="txtConteudo"
                pInputTextarea
                rows="16"
                [(ngModel)]="obj.conteudo"
              ></textarea>
            </habil-label>
            <small class="ajuda-dica">
              Exemplo: <code>## Como fazer</code>, depois os passos numerados; <code>## Atenção</code>, depois os
              pontos de cuidado.
            </small>
          </div>

          <div class="p-field p-col-12 p-md-6">
            <habil-label name="chkPublicado" label="Publicado (o ERP só recebe fichas publicadas)">
              <p-inputSwitch name="chkPublicado" [disabled]="_readonly" [(ngModel)]="obj.publicado"></p-inputSwitch>
            </habil-label>
          </div>
        </div>

        <!-- Sinaliza o estado que decide quem ganha na próxima publicação do
             catálogo. Sem isso, quem edita não tem como saber que o texto do
             repositório deixou de valer para esta ficha. -->
        <div class="ajuda-aviso" *ngIf="obj.editadoNaCentral">
          Esta ficha já foi editada aqui na central. As publicações do catálogo passam a preservar este texto — o
          arquivo do repositório não volta a sobrescrevê-lo.
        </div>
        <div class="ajuda-aviso ajuda-aviso--neutro" *ngIf="!obj.editadoNaCentral">
          Este texto ainda é o que veio do repositório. Ao salvar, ele passa a ser mantido aqui e as próximas
          publicações do catálogo deixam de sobrescrevê-lo.
        </div>
      </p-accordionTab>
    </p-accordion>
  </p-scrollPanel>
</habil-grupo>
<br />
<habil-botoes-cadastro
  (onError)="onErrorHandled()"
  [obj]="getObject.bind(this)"
  [dialog]="_isDialog"
  (onSaved)="onSave($event)"
  (onClosed)="onCancel()"
  [service]="service"
  [readonly]="_readonly"
  [validate]="doValidate.bind(this)"
  [doBeforeSave]="doBeforeSave.bind(this)"
>
</habil-botoes-cadastro>
